import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule, GrowlModule } from 'primeng/primeng';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';
import { Select2Module } from 'ng2-select2';
import { CardModule } from '../../../../layout/card';
import { MonitorsComponent } from './monitors.component';
import { MonitorService } from '../../../../common/services/Monitor.service';
import { GroupService } from '../../../../common/services/Group.service';
import { UserService } from '../../../../common/services/User.service';
import { ActivitiesComponent } from './activities/activities.component';
import { ChartModule } from 'angular2-highcharts';
import { ChatService } from '../../../../common/services/Chat.service';
import { ComponentsModule } from '../../../../components/component.module';
import { ChannelsComponent } from './channels/channels.component';
import { CallCenterComponent } from './call-center/call-center.component';
import { AgentsComponent } from './agents/agents.component';
import { CallMonitorComponent } from './call-monitor/call-monitor.component';
import { TooltipModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    GrowlModule,
    BrowserModule,
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot(),
    Select2Module,
    CardModule,
    ChartModule,
    ComponentsModule,
    TooltipModule,
  ],
  declarations: [
    MonitorsComponent,
    ActivitiesComponent,
    ChannelsComponent,
    CallCenterComponent,
    AgentsComponent,
    CallMonitorComponent,
  ],
  exports: [MonitorsComponent],
  providers: [MonitorService, GroupService, UserService, ChatService, GroupService],
})
export class MonitorsModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/monitors.module.ts